import { ImageUrl } from '@teemill/modules/images';

export const image = (url: string): ImageUrl => new ImageUrl(url, {});
